import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { injectIntl } from "react-intl";
import { Box, Button, Stack, Typography } from "@mui/material";
import { ArrowBackIosNewOutlined as ArrowBackIosNewOutlinedIcon } from "@mui/icons-material";
import { BACK, FOOTER_COOKIE_POLICY } from "../../../modules/language";
import { fetchCookiePolicyEnded, getCookiePolicy } from "../../../modules/prontoSoccorso";
import { Icona, LoadingSpinner } from "../../shared";
import { getMessageString } from "../../../utility";

export const Cookie = injectIntl(({ intl }) => {
  const navigate = useNavigate();
  const cookiePolicy = useSelector(getCookiePolicy);
  const cookiePolicyEnded = useSelector(fetchCookiePolicyEnded);

  return (
    <Box className="cookiePolicy">
      <Button startIcon={<ArrowBackIosNewOutlinedIcon />} onClick={() => navigate(-1)}>
        {getMessageString(intl, BACK)}
      </Button>
      <Stack className="pageTitle">
        <Icona tipologia="cookies" />
        <Typography variant="h2">{getMessageString(intl, FOOTER_COOKIE_POLICY)}</Typography>
      </Stack>
      {cookiePolicy && <div dangerouslySetInnerHTML={{ __html: cookiePolicy }} />}
      <LoadingSpinner loading={!cookiePolicyEnded} />
    </Box>
  );
});
